import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// In-memory token storage (not persisted to localStorage for security)
let _authToken = sessionStorage.getItem('vita_token') || null;

export const setAuthToken = (token) => {
  _authToken = token;
  if (token) sessionStorage.setItem('vita_token', token);
  else sessionStorage.removeItem('vita_token');
};

export const getAuthToken = () => _authToken;

export const clearAuth = () => {
  _authToken = null;
  sessionStorage.removeItem('vita_token');
  localStorage.removeItem('vita_user');
};

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  if (_authToken) {
    config.headers.Authorization = `Bearer ${_authToken}`;
  }
  return config;
});

// Handle 401s
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== '/' && !window.location.pathname.startsWith('/auth')) {
      clearAuth();
      window.location.href = '/auth';
    }
    return Promise.reject(err);
  }
);

export default api;
